import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GraphqlService } from 'src/app/graphql/graphql.service';
import { RfqSessionSupplier } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
	selector: 'pk-broker-pricing-session-supplier-notes-add-edit',
	standalone: false,
	templateUrl: './pricing-session-supplier-notes-add-edit.component.html',
	styleUrl: './pricing-session-supplier-notes-add-edit.component.scss',
})
export class PricingSessionSupplierNotesAddEditComponent extends AbstractPageForm {
	@Input() rfqSessionSupplier: RfqSessionSupplier;
	@Input() editNoteKey: string;

	@Output() backToNotes: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private fb: FormBuilder,
		private graphqlService: GraphqlService,
		private toastrService: ToastrService,
	) {
		super();
		this.submitText = 'Save';
		this.submittingText = 'Saving...';
	}

	public getForm() {
		return this.fb.group({
			note: [this.rfqSessionSupplier[this.editNoteKey], [Validators.required, Validators.maxLength(1000)]],
		});
	}

	public async onFormLoaded() {
		this.loading = false;
	}

	protected async onFormSubmitted() {
		try {
			await this.graphqlService.updateRfqSessionSupplier(this.rfqSessionSupplier.rfqSessionSupplierId, this.createRfqSessionSupplierDTO());
			this.toastrService.success('Supplier Note Successfully Updated');
			this.rfqSessionSupplier[this.editNoteKey] = this.form.note.value;
			this.backToNotes.emit();
		} catch (e) {
			this.toastrService.warning(
				`There was a problem updating the supplier note. We have been notified and are working to fix the issue. Please check back again in 30 minutes.`,
				'Supplier Note',
			);
			this.userAuditService.captureEvent(this.CONSTANTS.userAuditTypes.code, e.message, 'pricing-session-supplier-notes-add-edit:onFormSubmitted');
		}
	}

	private createRfqSessionSupplierDTO() {
		return {
			[this.editNoteKey]: this.form.note.value,
		};
	}
}
